import o from "../../../../../_virtual/index3.js";
var h = {
  red: 0,
  orange: 60,
  yellow: 120,
  green: 180,
  blue: 240,
  purple: 300
};
function t(e) {
  var u,
    l = [],
    i = 1,
    n;
  if (typeof e == "string") {
    if (o[e]) l = o[e].slice(), n = "rgb";else if (e === "transparent") i = 0, n = "rgb", l = [0, 0, 0];else if (/^#[A-Fa-f0-9]+$/.test(e)) {
      var a = e.slice(1),
        p = a.length,
        v = p <= 4;
      i = 1, v ? (l = [parseInt(a[0] + a[0], 16), parseInt(a[1] + a[1], 16), parseInt(a[2] + a[2], 16)], p === 4 && (i = parseInt(a[3] + a[3], 16) / 255)) : (l = [parseInt(a[0] + a[1], 16), parseInt(a[2] + a[3], 16), parseInt(a[4] + a[5], 16)], p === 8 && (i = parseInt(a[6] + a[7], 16) / 255)), l[0] || (l[0] = 0), l[1] || (l[1] = 0), l[2] || (l[2] = 0), n = "rgb";
    } else if (u = /^((?:rgb|hs[lvb]|hwb|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms)a?)\s*\(([^\)]*)\)/.exec(e)) {
      var r = u[1],
        y = r === "rgb",
        a = r.replace(/a$/, "");
      n = a;
      var p = a === "cmyk" ? 4 : a === "gray" ? 1 : 3;
      l = u[2].trim().split(/\s*[,\/]\s*|\s+/).map(function (f, g) {
        if (/%$/.test(f)) return g === p ? parseFloat(f) / 100 : a === "rgb" ? parseFloat(f) * 255 / 100 : parseFloat(f);
        if (a[g] === "h") {
          if (/deg$/.test(f)) return parseFloat(f);
          if (h[f] !== void 0) return h[f];
        }
        return parseFloat(f);
      }), r === a && l.push(1), i = y || l[p] === void 0 ? 1 : l[p], l = l.slice(0, p);
    } else e.length > 10 && /[0-9](?:\s|\/)/.test(e) && (l = e.match(/([0-9]+)/g).map(function (m) {
      return parseFloat(m);
    }), n = e.match(/([a-z])/ig).join("").toLowerCase());
  } else isNaN(e) ? Array.isArray(e) || e.length ? (l = [e[0], e[1], e[2]], n = "rgb", i = e.length === 4 ? e[3] : 1) : e instanceof Object && (e.r != null || e.red != null || e.R != null ? (n = "rgb", l = [e.r || e.red || e.R || 0, e.g || e.green || e.G || 0, e.b || e.blue || e.B || 0]) : (n = "hsl", l = [e.h || e.hue || e.H || 0, e.s || e.saturation || e.S || 0, e.l || e.lightness || e.L || e.b || e.brightness]), i = e.a || e.alpha || e.opacity || 1, e.opacity != null && (i /= 100)) : (n = "rgb", l = [e >>> 16, (e & 65280) >>> 8, e & 255]);
  return {
    space: n,
    values: l,
    alpha: i
  };
}
export { t as default };